import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../../../Payroll/helper-payroll/constants/payrollConstants";

export const _getHeaders_Reg = (selected, deductions) => {
  const { payrollType, jobType, payItem } = selected;
  const { additionalType, deductionType, contributionType } = deductions;
  const isBackPay = isBackPayItem(payItem);
  const isAddendumBackPay = isAddendumBackPayItem(payItem);
  //   const { additionalType, contributionType, deductionType } = deductions;

  const BasicPayGPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "OVERPAYMENT (BASIC)" },
    { rowSpan: 2, label: "OVERPAYMENT (PERA ADA)" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    // { rowSpan: 2, label: "Email" },
  ];
  const BasicPayGPSubheaders = [
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const BasicPayAPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "DATE OF ABSENCES" },
    { rowSpan: 2, label: "LEAVE WITHOUT PAY DATES" },
    { rowSpan: 2, label: "DATE OF HALF DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const BasicPayAPSubheaders = [
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const BasicPayBPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "DAYS IN A MONTH" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { colSpan: 1, label: "PERIOD COVERED" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA/ADA" },
    { rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" },
    { rowSpan: 2, label: "PERA/ADA FOR BACK-PAY" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const BasicPayBPSubheaders = [
    // "MONTH",
    // "YEAR",
    "DATE",
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const joBPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    ...(jobType === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "YEAR" }]
      : []),
    ...(jobType === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "MONTH" }]
      : []),
    { rowSpan: 2, label: "NO.OF DAYS" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCOUNT NUMBER" },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    ...(jobType === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" }]
      : []),
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINS TO BE DEDUCTED" },
    ...(jobType === "Job Order" && isBackPay
      ? [{ colSpan: 1, label: "PERIOD COVERED" }]
      : []),
    { colSpan: 5, label: "DEDUCTIONS BEFORE TAX" },
    { colSpan: 5, label: "WITHHOLDING TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const joBPSubHeaders = [
    ...(jobType === "Job Order" && isBackPay
      ? ["DATE"]
      : []),
    "ABSENCES DAYS",
    "ABSENCES MINS",
    "OVERPAYMENT",
    "FLAG RAISING",
    "EARNED FOR THE PERIOD",
    "3%",
    "2%",
    "5%",
    "10%",
    "TOTAL TAX",
    ...deductionType,
    ...additionalType,
  ];

  const AugmentationPayGPAPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    ...(isBackPay
      ? [{ rowSpan: 2, label: "YEAR" }]
      : []),
    ...(isBackPay
      ? [{ rowSpan: 2, label: "MONTH" }]
      : []),
    ...(isBackPay
      ? [{ colSpan: 1, label: "PERIOD COVERED" }]
      : []),
    { colSpan: 2, label: "PRESENT ASSIGNMENT" },
    {
      colSpan: 3,
      label: "AUGMENTATION(T1, T3, CIA, MCIA, & DIA)",
    },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "AP RATE" },
    ...(isBackPay
      ? [{ rowSpan: 2, label: "AP RATE FOR BACK-PAY" }]
      : []),
    { colSpan: 5, label: "CURRENT ASSIGNMENT" },
    { colSpan: 5, label: "AIRPORT AUGMENTATION" },
    { rowSpan: 2, label: "EXCESS AIRPORT DUTIES" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { colSpan: 2, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "NET EARNED" },
    { rowSpan: 2, label: "TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const AugmentationPayGPAPSubheaders = [
    ...(isBackPay ? ["DATE"] : []),
    "ABS",
    "LATES/ UT",
    "NO.OF DUTIES",
    "ABS",
    "LATES/UT",
    "TOTAL DAYS DUTY",
    "PRORATED AP RATE",
    "ABSENCES/LEAVES",
    "LATES/ UT",
    "EARNED CURRENT ASSIGNMENT",
    "AIRPORT AUGMENTATION RATE",
    "AMOUNT EARNED AIRPORT AUGMENTATION",
    "ABSENCES/LEAVES",
    "LATES/ UT",
    "EARNED AIRPORT DUTIES",
    "OVERPAYMENT",
    "FLAG RAISING",
    ...deductionType,
    ...additionalType,
  ];

  const IndividualHdrs = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "PLANTILLA ITEMS" },
    { rowSpan: 2, label: "GROSS" },
    { rowSpan: 2, label: "PERA/ADA" },
    { rowSpan: 2, label: "IN SERVICE" },
    { rowSpan: 2, label: "# OF DAYS 1 MONTH" },
    { rowSpan: 2, label: "HOL/ WKENDS/OFF" },
    { rowSpan: 2, label: "PRORATED RATE" },
    { rowSpan: 2, label: "PRORATED PERA" },
    { rowSpan: 2, label: "PER DAY" },
    { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "PER DAY" },
    { rowSpan: 2, label: "PER MINUTE" },
    { colSpan: 1, label: "DEDUCTION" },
    { colSpan: 1, label: "BASIC" },
    { colSpan: 1, label: "PERA ADA" },
    { rowSpan: 2, label: "DAYS FOR GSIS" },
    { rowSpan: 2, label: "BASIC EARNED" },
    { rowSpan: 2, label: "PERA ADA EARNED" },
    { rowSpan: 2, label: "TOTAL" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualSubHdrs = [
    // "DAYS",
    "MINS",
    // "DAYS",
    "MINS",
    // "BASIC",
    // "DAYS",
    "MINS",
    // "PERA",
    "TAX",
    ...contributionType,
  ];

  const IndividualJOHdrs = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCOUNT NUMBER" },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "PER DAY" },
    { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "ABS-DAYS" },
    { rowSpan: 2, label: "ABS-MINS" },
    { rowSpan: 2, label: "NO. OF DAYS PRESENT" },
    { rowSpan: 2, label: "EARNED" },
    { rowSpan: 2, label: "20%" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { rowSpan: 2, label: "WH TAX 3%" },
    { rowSpan: 2, label: "2%" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualJOSubHdrs = [];

  const IndividualAPInitialHdrs = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "Y=24/7 N=7:00-5:30" },
    { rowSpan: 2, label: "# of duty for CIA/MCIA/BINOC (Range to 15-19)" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "PLANTILLA ITEMS" },
    { rowSpan: 2, label: "AP RATE" },
    { rowSpan: 2, label: "DAILY RATE" },
    { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "OVERPAYMENT" },
    { rowSpan: 2, label: "FLAG RAISING" },
    { rowSpan: 2, label: "DAYS EARNED" },
    { rowSpan: 2, label: "NO. OF LATES INCURRED" },
    { rowSpan: 2, label: "LATES/UT DEDUCTION" },
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { rowSpan: 2, label: "TAX" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualAPInitialSubHdrs = [];

  const IndividualAPLastHdrs = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "Y=24/7 N=7:00-5:30" },
    { rowSpan: 2, label: "# of duty for CIA/MCIA/BINOC (Range to 15-19)" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "PLANTILLA ITEMS" },
    { rowSpan: 2, label: "AP RATE" },
    { rowSpan: 2, label: "DAILY RATE" },
    { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "OVERPAYMENT" },
    { rowSpan: 2, label: "FLAG RAISING" },
    { rowSpan: 2, label: "DAYS EARNED" },
    { rowSpan: 2, label: "NO. OF LATES INCURRED" },
    { rowSpan: 2, label: "LATES/UT DEDUCTION" },
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { rowSpan: 2, label: "TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualAPLastSubHdrs = [...deductionType];

  const IndividualRataHdrs = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    {
      rowSpan: 2,
      label: "REPRESENTATION ALLOWANCE/TRANSPORTATION ALLOWANCE (RATA)",
    },
    {
      rowSpan: 2,
      label: "NUMBER OF WORKDAYS OF ACTUAL WORK PERFORMANCE IN A MONTH",
    },
    { rowSpan: 2, label: "ACTUAL RATA FOR A MONTH" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualRataSubHdrs = [];

  const IPSalaryDiffBasicHdrs = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "TOTAL AMT EARNED" },
    { rowSpan: 2, label: "GSIS" },
    { rowSpan: 2, label: "PHILHEALTH" },
    { rowSpan: 2, label: "TAX" },
    { rowSpan: 2, label: "MY DIFF" },
    { rowSpan: 2, label: "YE DIFF" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IPSalaryDiffBasicSubHdrs = [];

  switch (true) {
    case payrollType === "Basic Pay" && payItem === "General Payroll":
      return [BasicPayGPHeaders, BasicPayGPSubheaders];
    case payrollType === "Basic Pay" &&
      jobType !== "Job Order" &&
      payItem === "Addendum Payroll":
      return [BasicPayAPHeaders, BasicPayAPSubheaders];
    case payrollType === "Basic Pay" && isAddendumBackPay:
      return [BasicPayBPHeaders, BasicPayBPSubheaders];
    case payrollType === "Basic Pay" && jobType === "Job Order":
      return [joBPHeaders, joBPSubHeaders];
    case payrollType === "Augmentation Pay" &&
      (payItem === "General Payroll" ||
        payItem === "Newly-Hired" ||
        isBackPay):
      return [AugmentationPayGPAPHeaders, AugmentationPayGPAPSubheaders];
    case payrollType === "Individual Payroll" &&
      jobType !== "Job Order" &&
      (payItem === "Initial Salary" || payItem === "Last Salary"):
      return [IndividualHdrs, IndividualSubHdrs];
    case payrollType === "Individual Payroll" &&
      jobType === "Job Order" &&
      (payItem === "Initial Salary" || payItem === "Last Salary"):
      return [IndividualJOHdrs, IndividualJOSubHdrs];
    case payrollType === "Individual Payroll" &&
      payItem === "Initial Salary(AP)":
      return [IndividualAPInitialHdrs, IndividualAPInitialSubHdrs];
    case payrollType === "Individual Payroll" && payItem === "Last Salary(AP)":
      return [IndividualAPLastHdrs, IndividualAPLastSubHdrs];
    case payrollType === "Individual Payroll" && payItem === "Initial RATA":
      return [IndividualRataHdrs, IndividualRataSubHdrs];
    case payrollType === "Individual Payroll" &&
      payItem === "Salary Differential (Basic)":
      return [IPSalaryDiffBasicHdrs, IPSalaryDiffBasicSubHdrs];
    default:
      return [[], [], []];
  }
};
